// IE 2026 10 29 / ODOO-5800 (ie-dm7 #115652: подписи чипса сортировки на языке пользователя): чипс CHIP-Order хранит в chip.title / doc.sortDescriptions[].title
// снимок подписей полей на момент сортировки (язык того, кто сортировал, или бэка — «Region, Product group», сохранённый в viewParams), а заголовки колонок грид берёт из
// attr_by_binding[binding].title (уже на языке пользователя). Подпись чипса при показе — по тому же правилу, что заголовок колонки: attr_by_binding[binding].title,
// иначе сохранённый title строки, иначе binding. Чистая логика — юнит tests/unit/orderChipTitle.test.mjs
export function orderChip_rowTitle(row, attrByBinding) {
    if (!row || typeof row !== 'object') return ''
    const b = row.binding
    const live = b != null && attrByBinding && typeof attrByBinding === 'object' ? attrByBinding[b]?.title : ''
    if (typeof live === 'string' && live.trim()) return live
    if (typeof row.title === 'string' && row.title.trim()) return row.title
    return b == null ? '' : String(b)
}

// подпись чипса: строки sortDescriptions через ', '; null — у чипса нет строк (вызывающий оставляет прежний путь — chip.title)
// fallbackT — перевод сохранённого title строки без колонки (литерал кода вроде 'Order'), по умолчанию как есть
export function orderChip_title(chip, attrByBinding, fallbackT) {
    const rows = chip?.doc?.sortDescriptions ?? chip?._raw?.doc?.sortDescriptions
    if (!Array.isArray(rows) || !rows.length) return null
    return rows.map(r => {
        const b = r?.binding
        const hasCol = b != null && attrByBinding && typeof attrByBinding[b]?.title === 'string' && attrByBinding[b].title.trim()
        const s = orderChip_rowTitle(r, attrByBinding)
        return (!hasCol && typeof fallbackT === 'function') ? fallbackT(s) : s
    }).join(', ')
}
